import { CreateTableState, Grid } from 'gu-ui-kit'
import React, { useEffect, useMemo, useState } from 'react'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import styles from 'modules/Referral/ReferralClients/referral-clients.module.scss'
import {
  NameCell,
  DateCell,
  BadgeCell,
  RevenueCell,
  LinkCell,
  ActionsCell,
  HeadCell,
} from 'modules/Referral/ReferralClients/subcomponents'

export const useTableConfig = ({ handleChangeName = () => {} }, data = []) => {
  const breakpoints = useBreakpoint()
  const [columnVisibility, setColumnVisibility] = useState()

  useEffect(() => {
    switch (true) {
      case breakpoints.fbs:
        setColumnVisibility({
          status: false,
          created_at: false,
          url: false,
          revenue: false,
        })
        break
      case breakpoints.lgs:
        setColumnVisibility({ status: false, created_at: false })
        break
      default:
        setColumnVisibility({})
        break
    }
  }, [breakpoints])

  const tableConfig = useMemo(
    () => ({
      columns: [
        {
          id: 'name',
          header: <HeadCell alias={'name'} tooltip={false} />,
          className: styles['referral-clients__cell_name'],
          cell: ({ row: { original } }) => (
            <Grid direction={'column'} gap={4} alignItems={'start'}>
              <NameCell {...original} handleChangeName={handleChangeName} />

              {breakpoints.lgs && (
                <Grid gap={8} direction={'column'}>
                  <DateCell {...original} />
                  <BadgeCell {...original} />
                  {breakpoints.fbs && (
                    <>
                      <LinkCell {...original} />
                      <RevenueCell {...original} />
                    </>
                  )}
                </Grid>
              )}
            </Grid>
          ),
        },
        {
          id: 'url',
          header: <HeadCell alias={'link'} tooltip={false} />,
          className: styles['referral-clients__cell_url'],
          cell: ({ row: { original } }) => <LinkCell {...original} />,
        },
        {
          id: 'status',
          header: <HeadCell alias={'status'} tooltip={false} />,
          className: styles['referral-clients__cell_status'],
          cell: ({ row: { original } }) => <BadgeCell {...original} />,
        },
        {
          id: 'created_at',
          header: <HeadCell alias={'created_at'} tooltip={false} />,
          className: styles['referral-clients__cell_created-at'],
          cell: ({ row: { original } }) => <DateCell {...original} />,
        },
        {
          id: 'revenue',
          header: <HeadCell alias={'revenue'} />,
          className: styles['referral-clients__cell_revenue'],
          cell: ({ row: { original } }) => <RevenueCell {...original} />,
        },
        {
          id: 'actions',
          header: ' ',
          isPlaceholder: true,
          className: styles['referral-clients__cell_actions'],
          cell: () => <ActionsCell />,
        },
      ],
      state: {
        columnVisibility,
      },
      showHeader: data?.length > 0,
      showFooter: false,
      className: styles['referral-clients__table'],
    }),
    [handleChangeName, columnVisibility, data],
  )

  return {
    tableState: CreateTableState(tableConfig, data),
    tableConfig,
  }
}
